import fox1 from "../../assets/images/arts/fox1.jpg";


const Story = () => {
    return (
        <div className="bg-sec" id="story">
            <div className="container my-md-5 my-0">
                <div className="row my-md-5 my-0">
                    <div className="col-lg-5" 
                     data-aos="fade-right" 
                     data-aos-delay="100">
                        <div className="hexa-i">

                        <img className="" src={fox1} alt="G Fox" />
                        </div>
                    </div>
                    <div className="col-lg-7 col-12 d-flex justify-content-center align-items-start flex-column my-md-0 my-3">
                        <div className="story-right-side">

                        <h2
                         data-aos="fade-down" 
                         className="head-ing  px-2 py-md-0 pt-2 sec-heading">Story</h2>
                        <p 
                         data-aos="fade-up" 
                        className="px-2">
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Fuga deserunt magnam aut odit quas soluta perferendis, at tenetur voluptatem eveniet architecto dolorum placeat sunt, cumque iure saepe hic ab laudantium error? Ab, quasi. Mollitia deserunt assumenda, voluptas fuga nisi ut ad optio quia debitis possimus temporibus perspiciatis at culpa pariatur. 
                            Lorem ipsum dolor sit amet 
                        </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Story
